
    import './styles.scoped.css';
    export default {
  "input-adorned-container": "awsui_input-adorned-container_2rhyz_9uioz_9",
  "input": "awsui_input_2rhyz_9uioz_9",
  "input-adorned-container-readonly": "awsui_input-adorned-container-readonly_2rhyz_9uioz_22",
  "input-readonly": "awsui_input-readonly_2rhyz_9uioz_22",
  "root": "awsui_root_2rhyz_9uioz_37",
  "input-invalid": "awsui_input-invalid_2rhyz_9uioz_140",
  "input-has-icon-start": "awsui_input-has-icon-start_2rhyz_9uioz_149",
  "input-warning": "awsui_input-warning_2rhyz_9uioz_152",
  "input-type-search": "awsui_input-type-search_2rhyz_9uioz_164",
  "input-has-icon-end": "awsui_input-has-icon-end_2rhyz_9uioz_177",
  "input-has-no-border-radius": "awsui_input-has-no-border-radius_2rhyz_9uioz_180",
  "grouped": "awsui_grouped_2rhyz_9uioz_187",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_2rhyz_9uioz_193",
  "grouped-in-error": "awsui_grouped-in-error_2rhyz_9uioz_200",
  "grouped-in-warning": "awsui_grouped-in-warning_2rhyz_9uioz_205",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_2rhyz_9uioz_235",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_2rhyz_9uioz_272",
  "grouped-horizontal-only": "awsui_grouped-horizontal-only_2rhyz_9uioz_314",
  "grouped-vertical-first": "awsui_grouped-vertical-first_2rhyz_9uioz_361",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_2rhyz_9uioz_403",
  "grouped-vertical-last": "awsui_grouped-vertical-last_2rhyz_9uioz_440",
  "grouped-vertical-only": "awsui_grouped-vertical-only_2rhyz_9uioz_482",
  "grouped-with-action": "awsui_grouped-with-action_2rhyz_9uioz_529",
  "grouped-validation": "awsui_grouped-validation_2rhyz_9uioz_533",
  "input-container": "awsui_input-container_2rhyz_9uioz_538",
  "input-icon-start": "awsui_input-icon-start_2rhyz_9uioz_543",
  "input-icon-end": "awsui_input-icon-end_2rhyz_9uioz_550",
  "input-button-right": "awsui_input-button-right_2rhyz_9uioz_556",
  "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_2rhyz_9uioz_560",
  "inline-label-trigger-wrapper-full-width": "awsui_inline-label-trigger-wrapper-full-width_2rhyz_9uioz_563",
  "inline-label-wrapper": "awsui_inline-label-wrapper_2rhyz_9uioz_567",
  "inline-label-wrapper-full-width": "awsui_inline-label-wrapper-full-width_2rhyz_9uioz_570",
  "inline-label": "awsui_inline-label_2rhyz_9uioz_560",
  "inline-label-disabled": "awsui_inline-label-disabled_2rhyz_9uioz_595",
  "input-adorned-container-disabled": "awsui_input-adorned-container-disabled_2rhyz_9uioz_620",
  "input-adorned-container-invalid": "awsui_input-adorned-container-invalid_2rhyz_9uioz_628",
  "input-adorned-container-warning": "awsui_input-adorned-container-warning_2rhyz_9uioz_641",
  "input-prefix": "awsui_input-prefix_2rhyz_9uioz_655",
  "input-suffix": "awsui_input-suffix_2rhyz_9uioz_656",
  "input-adornment-content": "awsui_input-adornment-content_2rhyz_9uioz_669",
  "input-adornment-divider": "awsui_input-adornment-divider_2rhyz_9uioz_678",
  "input-adorned": "awsui_input-adorned_2rhyz_9uioz_9"
};
  